import { getApiV2Client, NotificationsNotificationsSessionDto } from '@mi-front/api-v2';

/**
 * Fetches notifications provider session credentials for the authenticated user.
 */
export async function fetchNotificationsSession(): Promise<NotificationsNotificationsSessionDto> {
  const response = await getApiV2Client().request<NotificationsNotificationsSessionDto>(
    'GET',
    '/notifications/v1/session',
  );
  return response.data;
}
